module.exports = __webpack_public_path__ + "static/media/unaro-main.b845abea.svg";